export const SCALE_LABEL_LENGTH = 13;
export const GLOBAL_SCALE_LABEL_LAYOUT: IScalePackageBarcodeLayout = {
  totalLength: SCALE_LABEL_LENGTH,
  ignoredLeadingLength: 2,
  productBarcodeLength: 5,
  weightLength: 5,
};

/**
 * Scale prefixes are configured per device, so the frontend cannot identify a
 * scale label by a hard-coded namespace. The only safe local candidate check is
 * the contract shared by every supported scale label: exactly 13 digits.
 */
export const isScaleLabelCandidate = (barcode: string): boolean =>
  barcode.length === SCALE_LABEL_LENGTH && /^\d+$/.test(barcode);

export interface IScalePackageBarcodeLayout {
  totalLength: number;
  ignoredLeadingLength: number;
  productBarcodeLength: number;
  weightLength: number;
}

export interface IParsedScalePackageBarcode {
  shapeValid: boolean;
  productCode?: string;
  weightGrams?: number;
}

/** Local preview only. The API reparses the untouched barcode on submit. */
export const parseScalePackageBarcode = (
  barcode: string,
  layout: IScalePackageBarcodeLayout = GLOBAL_SCALE_LABEL_LAYOUT,
): IParsedScalePackageBarcode => {
  if (!Number.isInteger(layout.totalLength)) {
    return { shapeValid: false };
  }

  const shapeValid =
    layout.totalLength === SCALE_LABEL_LENGTH &&
    Number.isInteger(layout.ignoredLeadingLength) &&
    Number.isInteger(layout.productBarcodeLength) &&
    Number.isInteger(layout.weightLength) &&
    layout.ignoredLeadingLength >= 0 &&
    layout.productBarcodeLength > 0 &&
    layout.weightLength > 0 &&
    layout.ignoredLeadingLength +
      layout.productBarcodeLength +
      layout.weightLength <=
      SCALE_LABEL_LENGTH &&
    isScaleLabelCandidate(barcode);
  if (!shapeValid) return { shapeValid: false };

  const productStart = layout.ignoredLeadingLength;
  const productEnd = productStart + layout.productBarcodeLength;
  const weightEnd = productEnd + layout.weightLength;
  const productCode = barcode.slice(productStart, productEnd);
  const weightGrams = Number(barcode.slice(productEnd, weightEnd));

  return { shapeValid: true, productCode, weightGrams };
};
